import { style } from "@vanilla-extract/css";
import { vars } from "../../styles";

export const paginatorWrapper = style({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: vars.space.xs,
});
